import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./ServiceIconTextPair.module.scss";
export const ServiceIconTextPair = ({ icon, title }) => {
    return (_jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.iconWrapper, "aria-hidden": "true", children: icon }), _jsx("span", { className: styles.title, children: title })] }));
};
//# sourceMappingURL=ServiceIconTextPair.js.map